import { z } from "zod";
import { REPORT_SETTINGS_REPORT_KEYS } from "@common/types/reports/report-settings-report-key";
import { layoutOwnValuesSchema } from "./layout-setting.schema";
import { numberFormatOwnValuesSchema } from "./number-format-setting.schema";
import { templateReportSettingsOwnerSchema } from "./report-settings-owner.schema";
import {
    refineReportSettingsRowVisibility,
    saveReportSettingsNonEmptyFieldsSchema,
    saveReportSettingsReportKeySchema,
} from "./save-report-settings.schema";

export const templateReportSettingsRowSchema = z.object({
    owner: templateReportSettingsOwnerSchema,
    reportKey: z.enum(REPORT_SETTINGS_REPORT_KEYS),
    ...layoutOwnValuesSchema.shape,
    ...numberFormatOwnValuesSchema.shape,
});

export const templateReportSettingsResponseSchema = z.object({
    rows: z.array(templateReportSettingsRowSchema),
});
export type TemplateReportSettingsResponse = z.infer<
    typeof templateReportSettingsResponseSchema
>;

const saveTemplateReportSettingsChangeSchema = z
    .object({
        reportKey: saveReportSettingsReportKeySchema,
        fields: saveReportSettingsNonEmptyFieldsSchema,
    })
    .superRefine(refineReportSettingsRowVisibility);

export const saveTemplateReportSettingsBodySchema = z
    .object({
        changes: z.array(saveTemplateReportSettingsChangeSchema).min(1),
    })
    .refine(
        ({ changes }) =>
            new Set(changes.map(({ reportKey }) => reportKey)).size ===
            changes.length,
        { message: "Each report key can be changed only once" },
    );
export type SaveTemplateReportSettingsBody = z.infer<
    typeof saveTemplateReportSettingsBodySchema
>;
